module.exports = __webpack_public_path__ + "static/media/C0-GitHub.da45e471.svg";